import {BiUrls} from '../../biUrls';
import {MDMService} from '../services/mdmService.service';
import { Component, ViewChild, ElementRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'fileUpload',
    template: `<div class="modal-header border-bottom-0 px-4 pt-4 pb-3">
                <h5 *ngIf="!reUpload" class="text-xmd text-black bold m-0"> FILE UPLOAD</h5>
                <h5 *ngIf="reUpload" class="text-xmd text-black bold m-0"> RE UPLOAD FILE</h5>
                    <button type="button" class="close" aria-label="Close" (click)="activeModal.close()">
                         <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div *ngIf="!reUpload" class="col-lg-6 col-md-6 float-left">
                    <div class="form-group w-100 float-left">
                    <label for="recordFormat">Data Source</label>
                     <select class="form-control light-bg" (change)="selectDataSource($event)">
                        <option value='none'>None</option>
                        <option [attr.selected]="selectedDataSource == datasource.id ? true : null" *ngFor="let datasource of dataSourceList" [attr.value]='datasource.id' >{{datasource.name}}</option>
                     </select>
                    </div>
                </div>
                    <input type='file' class="mt-4 ml-2" #fileHolder  multipart=true name="file" (change)="fileChange($event)"/>
                <div class="modal-footer border-top-0 p-4">
                    <button [disabled]="saveButton" class="btn btn-primary" (click)="saveFile()">Save</button>
                </div>`
})

export class FileUploader {
    public dataSourceList: any = [];
    public selectedDataSource: any;
    public file: any;
    public saveButton: boolean = false;
    public parent: any;
    public reUpload: boolean = false;
    public recordFormat: any;
    public typeList: any = ['csv', 'psv', 'tsv', 'json', 'xlsx'];

    constructor(public activeModal: NgbActiveModal, public service: MDMService) {
        this.getDataSourceForDrill();
    }

    @ViewChild('fileHolder') fileDiv: ElementRef;

    getDataSourceForDrill() {
        let self = this;
        self.service.getAll('ds/type/DRILL').then(res => {
            self.dataSourceList = res.data != null ? res.data : [];
            if (self.dataSourceList && self.dataSourceList.length == 1) {
                self.selectedDataSource = self.dataSourceList[0].id;
            }
        });
    }

    saveFile() {
        let self = this;
        if (!self.reUpload) {
            let msg = self.validator();
            if (msg != '') {
                self.parent.toastr.showError(msg);
            } else {
                self.saveButton = true;
                let formdata1 = new FormData();
                formdata1.append('file', self.file);
                self.activeModal.close();
                self.parent.loader = true;
                self.service.uploadFileToDrill(BiUrls.UPLOAD_DRILL_FILE, formdata1, self.selectedDataSource).then((res) => {
                    self.saveButton = false;
                    if (res.success) {
                        self.parent.toastr.showSuccess("File upload successful");
                    } else if (res.message != null) {
                        self.parent.toastr.showError(res.message);
                    } else if (res.errorMessage != null) {
                        self.parent.toastr.showError(res.errorMessage);
                    } else {
                        self.parent.toastr.showError("File upload failed");
                    }
                    self.parent.loadRecords();
                    self.parent.loader = false;
                }, (err) => {
                    console.error(err);
                });
            }
        } else {
            self.reUploadFile();
        }
    }

    validator() {
        if (this.selectedDataSource == undefined || this.selectedDataSource == 'none') {
            return 'Please select Data-Source to upload a file !';
        }
        if (this.file == undefined) {
            return 'Please select a file to upload !';
        }
        let msg = this.fileValidator();
        if (msg) {
            return msg;
        }
        return '';
    }

    fileValidator() {
        if (this.file) {
            let name = this.file.name.split('.');
            let ext = name[name.length - 1];
            if (this.typeList.indexOf(ext) == -1) {
                return 'Please select ' + this.typeList.map(a => a.toUpperCase()).join(', ') + ' type file to upload';
            }
            let maxSize = 26214400; // 25MB
            let maxSizeInMB = maxSize / 1048576;
            if (this.file.size > maxSize) {
                return 'File size should not exceed ' + maxSizeInMB + 'MB';
            }
            return false;
        }
        return 'Please select a file to upload !';
       
    }

    public fileChange(event) {
        if (!this.reUpload && (this.selectedDataSource == undefined || this.selectedDataSource == 'none')) {
            this.parent.toastr.showError('Please select Data-Source to upload a file !');
            this.fileDiv.nativeElement.value = null;
        } else {
            this.file = event.target.files[0];
        }
    }

    selectDataSource(event) {
        if (event != 'none') {
            this.selectedDataSource = event.target.value;
        }
    }

    reUploadFile() {
        let self = this;
        if (!self.recordFormat) {
            self.parent.toastr.showError("Cannot re-upload!");
        }
        let validate = self.fileValidator();
        if (validate) {
            self.parent.toastr.showError(validate);
            self.fileDiv.nativeElement.value = null;
        } else {
            let formdata1 = new FormData();
            self.saveButton = true;
            formdata1.append('file', self.file);
            self.service.reUploadDrillFile(BiUrls.REUPLOAD_DRILL_FILE, formdata1, self.recordFormat).then((res) => {
                self.saveButton = false;
                if (res.success) {
                    self.parent.toastr.showSuccess("File re-uploaded successfull");
                } else {
                    self.parent.toastr.showError("File re-upload failed");
                }
                self.parent.loadRecords();
                self.parent.loader = false;
            }, (err) => {
                console.error(err);
            });
            self.activeModal.close();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/fileUploadModal.ts